module.exports = __webpack_public_path__ + "img/install_02.7a6fdd9c.jpg";